"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierRef = exports.OperandRef = exports.FunctionRef = exports.FunctionDef = exports.ExpressionRef = exports.ExpressionDef = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var ExpressionDef = /** @class */ (function (_super) {
    __extends(ExpressionDef, _super);
    function ExpressionDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.context = json.context;
        _this.expression = (0, builder_1.build)(json.expression);
        return _this;
    }
    ExpressionDef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var value, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.expression != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.expression.execute(ctx)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _b.label = 3;
                    case 3:
                        value = _a;
                        ctx.rootContext().set(this.name, value);
                        return [2 /*return*/, value];
                }
            });
        });
    };
    return ExpressionDef;
}(expression_1.Expression));
exports.ExpressionDef = ExpressionDef;
var ExpressionRef = /** @class */ (function (_super) {
    __extends(ExpressionRef, _super);
    function ExpressionRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    ExpressionRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = this.library ? ctx.getLibraryContext(this.library) : ctx;
                        value = ctx.get(this.name);
                        if (!(value instanceof expression_1.Expression)) return [3 /*break*/, 2];
                        return [4 /*yield*/, value.execute(ctx)];
                    case 1:
                        value = _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, value];
                }
            });
        });
    };
    return ExpressionRef;
}(expression_1.Expression));
exports.ExpressionRef = ExpressionRef;
var FunctionDef = /** @class */ (function (_super) {
    __extends(FunctionDef, _super);
    function FunctionDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.parameters = json.operand;
        return _this;
    }
    FunctionDef.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this];
            });
        });
    };
    return FunctionDef;
}(expression_1.Expression));
exports.FunctionDef = FunctionDef;
var FunctionRef = /** @class */ (function (_super) {
    __extends(FunctionRef, _super);
    function FunctionRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    FunctionRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var functionDefs, child_ctx, lib, libCtx, args, functionDef, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.library) {
                            lib = ctx.get(this.library);
                            functionDefs = lib ? lib.getFunction(this.name) : undefined;
                            libCtx = ctx.getLibraryContext(this.library);
                            child_ctx = libCtx ? libCtx.childContext() : undefined;
                        }
                        else {
                            functionDefs = ctx.get(this.name);
                            child_ctx = ctx.childContext();
                        }
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        // Filter out functions w/ wrong number of arguments.
                        functionDefs = functionDefs.filter(function (f) { return f.parameters.length === args.length; });
                        // If there is still > 1 matching function, filter by argument types
                        if (functionDefs.length > 1) {
                            functionDefs = functionDefs.filter(function (f) {
                                var match = true;
                                for (var i = 0; i < args.length && match; i++) {
                                    if (args[i] !== null) {
                                        var operandTypeSpecifier = f.parameters[i].operandTypeSpecifier;
                                        if (operandTypeSpecifier == null && f.parameters[i].operandType != null) {
                                            // convert it to a NamedTypedSpecifier
                                            operandTypeSpecifier = {
                                                name: f.parameters[i].operandType,
                                                type: 'NamedTypeSpecifier'
                                            };
                                        }
                                        match = ctx.matchesTypeSpecifier(args[i], operandTypeSpecifier);
                                    }
                                }
                                return match;
                            });
                        }
                        // If there is still > 1 matching function, calculate a score based on quality of matches
                        if (functionDefs.length > 1) {
                            // TODO
                        }
                        if (functionDefs.length === 0) {
                            throw new Error('no function with matching signature could be found');
                        }
                        functionDef = functionDefs[functionDefs.length - 1];
                        for (i = 0; i < functionDef.parameters.length; i++) {
                            child_ctx.set(functionDef.parameters[i].name, args[i]);
                        }
                        return [2 /*return*/, functionDef.expression.execute(child_ctx)];
                }
            });
        });
    };
    return FunctionRef;
}(expression_1.Expression));
exports.FunctionRef = FunctionRef;
var OperandRef = /** @class */ (function (_super) {
    __extends(OperandRef, _super);
    function OperandRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    OperandRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ctx.get(this.name)];
            });
        });
    };
    return OperandRef;
}(expression_1.Expression));
exports.OperandRef = OperandRef;
var IdentifierRef = /** @class */ (function (_super) {
    __extends(IdentifierRef, _super);
    function IdentifierRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    IdentifierRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var lib, val, parts, curr_obj, _i, _a, part, _obj;
            return __generator(this, function (_b) {
                lib = this.library ? ctx.get(this.library) : undefined;
                val = lib ? lib.get(this.name) : ctx.get(this.name);
                if (val == null) {
                    parts = this.name.split('.');
                    val = ctx.get(parts[0]);
                    if (val != null && parts.length > 1) {
                        curr_obj = val;
                        for (_i = 0, _a = parts.slice(1); _i < _a.length; _i++) {
                            part = _a[_i];
                            _obj = void 0;
                            if (curr_obj != null) {
                                _obj = curr_obj[part];
                                if (_obj === undefined && typeof curr_obj.get === 'function') {
                                    _obj = curr_obj.get(part);
                                }
                            }
                            curr_obj = _obj instanceof Function ? _obj.call(curr_obj) : _obj;
                        }
                        val = curr_obj;
                    }
                }
                if (val instanceof Function) {
                    return [2 /*return*/, val.call(ctx.context_values)];
                }
                else {
                    return [2 /*return*/, val];
                }
                return [2 /*return*/];
            });
        });
    };
    return IdentifierRef;
}(expression_1.Expression));
exports.IdentifierRef = IdentifierRef;
//# sourceMappingURL=reusable.js.map